/**
 * Módulos existentes na aplicação e que podem ser controlados (permissões).
 */
const Module = {

    DASHBOARD: 'DASHBOARD',
    REGISTRATION: 'REGISTRATION',
    APPOINTMENT: 'APPOINTMENT',
    STOCK_CONTROL: 'STOCK_CONTROL',
    CASH_FLOW: 'CASH_FLOW',
    SALES: 'SALES',
    PERFORMANCE: 'PERFORMANCE',
    GAMIFICATION: 'GAMIFICATION',
    SUBSCRIPTION: 'SUBSCRIPTION',
    INTEGRATION: 'INTEGRATION',
    WHATSAPP: 'WHATSAPP',

    // Central de Relatórios: hub que reúne os relatórios dos demais módulos.
    REPORTS: 'REPORTS'
}

export default Module;
